module.exports = __webpack_public_path__ + "static/media/rating_3.fd74dff2.png";